module.exports = __webpack_public_path__ + "media/icons/mail-7c455d5a.png";